import script from "./ExportItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ExportItem.vue?vue&type=script&setup=true&lang=ts"

import "./ExportItem.vue?vue&type=style&index=0&id=65c33d0f&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-65c33d0f"]])

export default __exports__